import { makeVar } from '@apollo/client'

export const isSignUpDialogOpenVar = makeVar(false)
export const isSignInDialogOpenVar = makeVar(false)

export const isConnectWalletDialogOpenVar = makeVar(false)

export const isConnectWalletOpenVar = makeVar(false)

export const isDemoQuotaConversionVar = makeVar(false)
